<template>
  <a class="mb-2 btn-transition btn btn-outline-success float-right" href="#" @click.prevent="addNewModal">Add new</a>
</template>
<script>
export default {
  props: {
    config: Object
  },
  methods: {
    addNewModal() {
      this.$emitter.emit('Modal', {
        name: 'automation.create',
        data: {},
        $el: null
      })
    }
  }
}
</script>
